
import React from 'react';

import { Tabs } from 'antd';
import CreateDrivers from './CreateDrivers';
import Pharmacies from './Pharmacies';
import OrdersAsing from './OrdersAsing'


const { TabPane } = Tabs;
export default function DriverAdminTap() {
    return (
        <div>
            <Tabs type="card">
                <TabPane tab="Drivers" key="1">
                    <CreateDrivers />
                </TabPane>
                <TabPane tab="Pharmacies" key="2">
                    {/* <AdsPlansAdmin /> */}
                    <Pharmacies />
                </TabPane>
                <TabPane tab="Order" key="3">
                    <OrdersAsing />
                </TabPane>
                <TabPane tab="Map" key="4">
                    {/* <AdminAdsToPharmacy /> */}
                </TabPane>

            </Tabs>
        </div>
    )
}